import { Card, Col, Row, Typography } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { images } from "../../../routes/ImageRoutes";
const { Text } = Typography;

const SocialNetworking = () => {
    return (
        <Card style={styles.rowRoot} bodyStyle={{ padding: 10 }}>
            <Row>
                <Col style={styles.colView} span={24} >
                    <div style={{marginRight: 20}}>
                        <Text style={styles.textTitle}>{"Todas tus recargas incluyen"}</Text>
                        <br />
                        <Text style={styles.textTitle}>{"REDES SOCIALES"}</Text>
                    </div>
                    <img style={{width: 150}} src={images.redesSociales} alt="redes" />
                </Col>
            </Row>
        </Card>
    );
};

const styles = StyleSheet.create({
    rowRoot: {
        backgroundColor: "#0055c2",
        padding: 0,
        borderRadius: 15,
        boxShadow: "0px 0px 8px #00000029",
    },
    textTitle: {
        fontSize: 20,
        color: "white",
        fontWeight: 600,
    },
    colView: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 20,
        justifyContent: 'flex-end',
        textAlign: 'end',
        paddingRight: 10
    },
});

export default SocialNetworking;
